import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  [x: string]: any;

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(): Observable<boolean> | boolean {

    return this.authService.loggedIn$.pipe(map((loggedIn: boolean) => {
      console.log("auth guard loggedIn: ", loggedIn)

      if (!loggedIn) {
        this.router.navigate(['auth']);
        return false
      }
      return true;
    }))
      
  }


}
